// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Lebanon from '../_raw/flag/icon_flag_lebanon.png';

export default () => <img src={Lebanon} alt="Lebanon" />;
